import type { ContextSessionResponse } from "@kontextwerk/control-web-client"
import { CORE_CAPABILITY_DEFINITIONS } from "@kontextwerk/control-web-frame/shared/logic/authorization"
import {
    evaluateCapabilities,
    type CapabilityDefinition,
} from "@kontextwerk/control-web-frame/shared/logic/authorization"

/** Projection of app/config/capability_catalog.py; legacy aliases never grant access. */
export const KEHRBLATT_CONTEXT_CATALOG: readonly CapabilityDefinition[] = Object.freeze([
  ...CORE_CAPABILITY_DEFINITIONS,
  Object.freeze({
    key: "kehrblatt.registry",
    levels: Object.freeze(["view", "manage"] as const),
    scopes: Object.freeze([]),
  }),
  Object.freeze({
    key: "kehrblatt.scheduling",
    levels: Object.freeze(["view", "manage"] as const),
    scopes: Object.freeze(["own", "all"] as const),
  }),
  Object.freeze({
    key: "kehrblatt.demo_reset",
    levels: Object.freeze(["view", "manage"] as const),
    scopes: Object.freeze([]),
  }),
])

export const allowsKehrblattCapability = (
  session: ContextSessionResponse | null,
  key: string,
  level: "view" | "manage",
  scope?: "own" | "all",
) => {
  if (
    !session ||
    session.product_issuer !== "kehrblatt-control" ||
    session.password_change_required ||
    session.context.kind !== "organization"
  )
    return false

  const expiry = session.context.delegation?.expires_at

  if (expiry && (!Number.isFinite(Date.parse(expiry)) || Date.parse(expiry) <= Date.now()))
    return false

  return evaluateCapabilities(session, KEHRBLATT_CONTEXT_CATALOG, {
    operation: `${key}.${level}`,
    all_of: [{ key, level, scope }],
  }).allowed
}
